import { useEffect } from "react";
import { useLocation } from "react-router-dom";

type PaymentReturnStatus = "success" | "cancel";

const labels: Record<PaymentReturnStatus, { title: string; message: string; icon: string; className: string }> = {
  success: {
    title: "Paiement confirmé",
    message: "Nous ouvrons l'application Foi Sénégal pour finaliser votre confirmation.",
    icon: "ri-checkbox-circle-fill",
    className: "text-emerald-500",
  },
  cancel: {
    title: "Paiement interrompu",
    message: "Nous ouvrons l'application Foi Sénégal pour reprendre votre paiement.",
    icon: "ri-close-circle-fill",
    className: "text-amber-500",
  },
};

export default function PaymentReturnPage() {
  const location = useLocation();
  const status: PaymentReturnStatus = location.pathname.includes("/cancel") ? "cancel" : "success";
  const content = labels[status];
  const appUrl = `foisenegal://payment/${status}`;

  useEffect(() => {
    const timeout = window.setTimeout(() => {
      window.location.href = appUrl;
    }, 400);

    return () => window.clearTimeout(timeout);
  }, [appUrl]);

  return (
    <main className="flex min-h-screen items-center justify-center bg-[#f7f8fb] px-5 py-10">
      <section className="w-full max-w-md rounded-[8px] bg-white p-8 text-center shadow-sm">
        <i className={`${content.icon} ${content.className} text-6xl`} aria-hidden="true" />
        <h1 className="mt-5 text-2xl font-bold text-navy">{content.title}</h1>
        <p className="mt-3 text-sm leading-6 text-gray-500">{content.message}</p>
        <a
          href={appUrl}
          className="mt-7 inline-flex w-full items-center justify-center rounded-[8px] bg-navy px-5 py-3 text-sm font-semibold text-white"
        >
          Ouvrir Foi Sénégal
        </a>
      </section>
    </main>
  );
}
